var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.galleryImages
    ? _c(
        "div",
        { staticClass: "column is-narrow media-sidebar" },
        [
          _vm.galleryItems
            ? _c(
                "div",
                { staticClass: "gallery__items" },
                _vm._l(JSON.parse(_vm.galleryImages), function (image, index) {
                  return _c("div", { key: index }, [
                    _c(
                      "button",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleGalleryItems(image)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: image,
                            alt: "",
                            width: "600",
                            height: "600",
                          },
                        }),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("DialogElement", {
            attrs: { dialogToggle: _vm.dialogToggle, maxWidth: "600" },
            on: { closeDialog: _vm.closeDialog },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm.currentGalleryItem
                        ? _c("div", [
                            _c("div", { staticClass: "media-item__large" }, [
                              _c("img", {
                                attrs: {
                                  alt: "",
                                  src: _vm.currentGalleryItem,
                                  width: "600",
                                  height: "600",
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1847076477
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }